import utility from './utility'

const unsubscribeNotifications = {
    init: function () {
        const unsubscribeForm = document.getElementById("account--unsubscribe-form");
        if (unsubscribeForm) {
            unsubscribeForm.onsubmit = () => {
                unsubscribeNotifications.disableSubmitButton();
                grecaptcha.ready(function () {
                    grecaptcha.execute('6LfLgkkeAAAAAJjWeGBuwbL9vpDkOpKLfmiev0Rh', { action: 'unsubscribe' }).then(function (token) {
                        document.getElementById('g-recaptcha-response').value = token;
                        unsubscribeNotifications.submitForm();
                    });
                });
                return false;
            };
        }
    },

    submitForm: function () {
        const selectedOption = document.querySelector("#account--unsubscribe-form input[name='typeId']:checked");
        if (!selectedOption) {
            document.getElementById("account--unsubscribe-selection-error").style.display = "";
            unsubscribeNotifications.enableSubmitButton();
            return;
        }
        const type = document.querySelector("#account--unsubscribe-form input[name='typeId']:checked");
        if (type && type.value === "L") {
            const checkedCount = document.querySelectorAll("#account--unsubscribe-form input[name='lotteryIds']:checked").length;
            if (checkedCount === 0) {
                document.getElementById("account--unsubscribe-lottery-error").style.display = "";
                unsubscribeNotifications.enableSubmitButton();
                return;
            }
        }
        document.getElementById("account--unsubscribe-selection-error").style.display = "none";
        const lotteryError = document.getElementById("account--unsubscribe-lottery-error");
        if (lotteryError) {
            lotteryError.style.display = "none";
        }
        const ajaxOptions = {
            url: document.getElementById("account--unsubscribe-form").action,
            method: "POST",
            data: utility.getFormData(document.querySelector("#account--unsubscribe-form")),
            success: function (e) {
                const result = JSON.parse(e.target.responseText);
                const form = document.querySelector("#account--unsubscribe-form");
                utility.removeFormInputErrors(form);
                if (result.success) {
                    utility.showNotificationPopup({
                        title: "Success",
                        content: result.message,
                        hideCloseIcon: true,
                        button: {
                            url: "/"
                        }
                    });
                    [...form.querySelectorAll("input[type=text]")].map(input => { input.value = ""; });
                }
                else {
                    utility.addFormInputError(form, "phone", result.message);
                }
            },
            always: function () {
                unsubscribeNotifications.enableSubmitButton();
            }
        };
        utility.ajaxRequest(ajaxOptions);
    },

    disableSubmitButton: function () {
        utility.disableButton(document.querySelector("#account--unsubscribe-form button[type=submit]"));
    },

    enableSubmitButton: function () {
        utility.enableButton(document.querySelector("#account--unsubscribe-form button[type=submit]"));
    }
}

export default unsubscribeNotifications


// WEBPACK FOOTER //
// ./assets/src/js/classes/unsubscribe.js